var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.7067 14.5654L30.4439 13.5099L32.7067 12.4545L33.7352 10.1324L34.7637 12.4545L37.0264 13.5099L34.7637 14.5654L33.7352 16.8874L32.7067 14.5654ZM27.235 6.67053L23.8615 5.06622L27.235 3.46192L28.7983 0L30.3617 3.46192L33.7352 5.06622L30.3617 6.67053L28.7983 10.1324L27.235 6.67053ZM12.3421 37.1523C11.437 37.1523 10.6625 36.8219 10.0185 36.161C9.37344 35.499 9.0509 34.7036 9.0509 33.7748H15.6334C15.6334 34.7036 15.3114 35.499 14.6674 36.161C14.0223 36.8219 13.2472 37.1523 12.3421 37.1523ZM7.40528 32.0861C6.93902 32.0861 6.54792 31.924 6.23196 31.5997C5.9171 31.2766 5.75967 30.8758 5.75967 30.3973C5.75967 29.9189 5.9171 29.5181 6.23196 29.195C6.54792 28.8707 6.93902 28.7086 7.40528 28.7086H17.279C17.7453 28.7086 18.1364 28.8707 18.4523 29.195C18.7672 29.5181 18.9246 29.9189 18.9246 30.3973C18.9246 30.8758 18.7672 31.2766 18.4523 31.5997C18.1364 31.924 17.7453 32.0861 17.279 32.0861H7.40528ZM6.17107 27.0199C4.27861 25.8659 2.77726 24.3179 1.66701 22.3758C0.555671 20.4338 0 18.3228 0 16.043C0 12.5248 1.2002 9.53464 3.60061 7.07245C5.99993 4.60914 8.91377 3.37748 12.3421 3.37748C15.7705 3.37748 18.6844 4.60914 21.0837 7.07245C23.4841 9.53464 24.6843 12.5248 24.6843 16.043C24.6843 18.3228 24.1292 20.4338 23.0189 22.3758C21.9076 24.3179 20.4057 25.8659 18.5132 27.0199H6.17107Z",
    fill: "#D29F3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.2c90396e.svg";
export { ForwardRef as ReactComponent };